/**
 * 태그 데이터를 BadgeList 컴포넌트에서 사용할 수 있는 형태로 변환
 *
 * @param tags - 변환할 태그 배열
 * @returns BadgeList에 전달할 수 있는 badge 아이템 배열
 */
export const mapTagsToBadgeItems = (tags: Array<{ tagFQN: string; name: string }>) => {
  return tags.map((tag) => ({
    tagFQN: tag.tagFQN,
    name: tag.name,
    displayName: tag.name,
  }));
};
